import React, { useState, useEffect, useRef } from "react";
import { capitalizeWords } from "../Inventario/helper/CapitalizeWords";
import { FormatMoney } from '../../../Helpers/FormatNumber'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { ModalModificarImagen } from "../Inventario/ModalModificarImagen";
import { ModalImagen } from "../Inventario/ModalImagen";
import { ModalCarruselImagenes } from "./ModalCarruselImagenes";
import CollectionsIcon from '@mui/icons-material/Collections';
import TractorIcon from "../../../Styles/Usados/tractor.png"
import TrilladoraIcon from "../../../Styles/Usados/vehiculo.png"
import CabezalIcon from "../../../Styles/Usados/arado.png"


export const TablaListadoPrecios = ({ datos, ObtenerListado, filtrar, setFiltrar, setKeyFiltrado }) => {
    const containerRef = useRef(null); // Crear el ref

    const [openModal, setOpenModal] = useState(false);
    const [imagenes, setImagenes] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    // console.log(guardar)

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    const handleOpen = async (rowData) => {
        if (rowData.tiene_imagen === "N") {
            return;
        }
        else {
            setSelectedRow(rowData);
            setLoader({ ...loader, mostrar: true });

            try {
                const result = await request.get(`ImagenesMaquinaria/BuscarImagenes?idinventario=${rowData.idinventario}`);

                if (result && result.length > 0) {
                    setImagenes(result);
                    setOpenModal(true);
                    setLoader({ ...loader, mostrar: false });
                } else {
                    Swal.fire("Imagenes", "Este tractor no cuenta con imagenes", "warning");
                    setLoader({ ...loader, mostrar: false });
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleClose = () => setOpenModal(false);


    const onEstatus = (estatus) => {
        if (estatus === "L") {
            return "info-estatus-circulo circulo-verde"
        }
        else if (estatus === "A") {
            return "info-estatus-circulo circulo-amarillo"
        }
        else if (estatus === "V") {
            return "info-estatus-circulo circulo-rojo"
        }
    }


    const onFiltrar = (filtro) => {
        setFiltrar(!filtrar)
        setKeyFiltrado(filtro)
    }

    const getMonthName = (dateString) => {
        const currentDate = new Date();  // Obtiene la fecha actual
        const currentMonth = currentDate.getMonth();  // Obtiene el número de mes (0 - 11)

        if (!dateString) return '';

        const [day, month, year] = dateString.split('/');
        const monthNames = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        // Concatenamos el nombre del mes actual y el mes del dateString
        return monthNames[currentMonth] + ' - ' + monthNames[parseInt(month) - 1];
    };

    const familiasOrdenadas = ["Tractores", "Trilladoras", "Cabezales", "Implementos"];

    const clasificarFamilia = (modelo) => {

        if (
            modelo.toLowerCase().includes("tractor") ||
            modelo.toLowerCase().includes("tr-") ||
            modelo.toLowerCase().includes("tr ")
        ) {
            return "Tractores";
        }
        if (modelo.toLowerCase().includes("trilladora")) return "Trilladoras";
        if (modelo.toLowerCase().includes("cabezal")) return "Cabezales";
        return "Implementos";
    };

 //filter(dato => dato.estatus === "L")
    const datosAgrupados = datos.reduce((acc, dato) => {
        const familia = clasificarFamilia(dato.modelo_descripcion);
        if (!acc[familia]) acc[familia] = [];
        acc[familia].push(dato);
        return acc;
    }, {});

    // Ordenamos los datos dentro de cada familia primero por 'estatus' (L antes que A), luego por 'sucursal' y finalmente por 'hp'
    Object.keys(datosAgrupados).forEach(familia => {
        datosAgrupados[familia].sort((a, b) => {
            // Primero, ordenar por 'estatus' (L antes que A)
            if (a.estatus === "L" && b.estatus !== "L") return -1; // 'L' antes que 'A'
            if (a.estatus !== "L" && b.estatus === "L") return 1;  // 'A' después que 'L'

            // Si ambos tienen el mismo 'estatus', ordenar por 'sucursal'
            if (a.estatus === b.estatus) {
                if (a.sucursal !== b.sucursal) {
                    return a.sucursal - b.sucursal; // Orden ascendente por 'sucursal'
                }

                // Si ambos tienen el mismo 'estatus' y 'sucursal', ordenar por 'hp'
                return a.hp - b.hp; // Orden ascendente por 'hp'
            }

            return 0;
        });
    });

    const [stickyHeaders, setStickyHeaders] = useState({});

    useEffect(() => {
        const handleScroll = () => {
            if (!containerRef.current) return;

            const rows = containerRef.current.querySelectorAll(".familia-header");
            let currentHeader = null;

            rows.forEach(row => {
                const rect = row.getBoundingClientRect();
                if (rect.top <= 60) { // Ajusta la altura según sea necesario
                    currentHeader = row.innerText;
                }
            });

            setStickyHeaders(prevState => ({
                ...prevState,
                current: currentHeader,
            }));
        };

        // Esperamos a que el `ref` tenga un valor antes de agregar el evento
        if (containerRef.current) {
            containerRef.current.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (containerRef.current) {
                containerRef.current.removeEventListener("scroll", handleScroll);
            }
        };
    }, [containerRef.current]);

    const obtenerIconoFamilia = (familia) => {
        switch (familia) {
            case 'Tractores':
                // return <AgricultureOutlinedIcon />;
                return <img src={TractorIcon} alt="Tractor" className="img-trilladora" />;
            case 'Trilladoras':
                return <img src={TrilladoraIcon} alt="Trilladora" className="img-trilladora" />;
            default:
                return <img src={CabezalIcon} alt="Cabezal" className="img-trilladora" />;
        }
    };

    return (
        <div className="listado-precios-container">
            <LoaderScreen loader={loader} />
            <div className="listado-precios-visualizacion-container-table scroll">
                <table cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <th className="celda-vacia-1"></th>
                            <th className="celda-vacia-2"></th>
                            <th className="celda-vacia-3"></th>
                            <th className="celda-fija">
                                EQUIPO
                            </th>
                            <th className="celda-fija-2">
                                <div>N.E</div>
                            </th>
                            <th>
                                <div>MARCA</div>
                            </th>
                            <th>
                                <div>AÑO</div>
                            </th>
                            <th>
                                <div>HP</div>
                            </th>
                            <th>
                                <div>HORAS</div>
                            </th>
                            <th>
                                <div>PRECIO</div>
                            </th>
                            <th>
                                <div>PROMOCION</div>
                            </th>
                            <th>
                                <div>ESTATUS</div>
                            </th>
                            <th>
                                <div>SUCURSAL</div>
                            </th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {familiasOrdenadas.map(familia => (
                            datosAgrupados[familia] ? (
                                <React.Fragment key={familia}>
                                    <tr className="familia-header sticky-familia">
                                        <td colSpan={5} className="celda-fija-familia">
                                            <div className="celda-titulo-familia">
                                                {obtenerIconoFamilia(familia)}
                                                {familia.toUpperCase()}
                                            </div>
                                        </td>
                                        {/* <td></td> */}
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                    </tr>
                                    {datosAgrupados[familia].map((datos, index) => (
                                        <tr key={datos.id || index}>
                                            <td className="celda-circulo celda-fija-numero">{index + 1}</td>
                                            <td className="celda-circulo celda-fija">
                                                <div className={onEstatus(datos.estatus)}></div>
                                            </td>
                                            <td className="celda-img celda-fija-img"><div className={datos.tiene_imagen === "S" ? "img" : "img-sin-color"} onClick={() => handleOpen(datos)}><CollectionsIcon /></div></td>
                                            <td className="celda-modelo celda-fija-3">{datos.modelo_descripcion}</td>
                                            <td className="celda-numecon celda-fija-4">{datos.ne}</td>
                                            <td className="celda-marca ta-center">{datos.marca = 'JD' ? 'JOHN DEERE' : datos.marca}</td>
                                            <td className='celda-chica'>{datos.ejercicio}</td>
                                            <td className='celda-chica'>{datos.hp}</td>
                                            <td className='celda-chica'>{datos.horas}</td>
                                            <td className='celda-importe ta-center'>{datos.estatus === 'L' ? FormatMoney(datos.precio_lista) : 0.00}</td>
                                            <td className="celda-promocion ta-center">
                                                {datos.promocion ? datos.promocion.toUpperCase() : ''}
                                                <br />
                                                {datos.vigencia}
                                            </td>
                                            <td className='celda-chica'>{datos.estatus === "L" ? "LISTO PARA LA VENTA" : datos.estatus === "A" ? "ACONDICIONANDO" : "NO IDENTIFICADO"}</td>
                                            {/* <td className='celda-chica'>{getMonthName(datos.vigencia)}</td> */}
                                            <td className="celda-marca ta-center">{datos.nombre_sucursal}</td>
                                            
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ) : null
                        ))}
                        {/* ))} */}
                    </tbody>
                </table>
                {/* )  */}
            </div>

            <div className="listado-precios-footer-container-c">
                <div className="listado-precios-info-container">
                    <div className="info-estatus">

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("L")}>
                            <div className="info-estatus-circulo circulo-verde"></div>
                            Listo para la venta
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("A")}>
                            <div className="info-estatus-circulo circulo-amarillo"></div>
                            Acondicionando
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("T")}>
                            <div className="info-estatus-circulo circulo-dividido"></div>
                            Todos
                        </div>
                        {/* <div className="info-estatus green">
                            <div className="info-estatus-circulo circulo-rojo"></div>
                            Vendido
                        </div> */}

                    </div>
                    <div></div>
                </div>
            </div>
            <ModalCarruselImagenes open={openModal} handleClose={handleClose} datos={selectedRow} imagenesBD={imagenes} />
            {/* <ModalPromociones
                open={openModalModificarPromo}
                handleClose={handleCloseModificarPromo}
                datos={selectedRow}
                ObtenerListado={ObtenerListado}
            /> */}
            {/* <ModalAgregarPromociones
                open={openModalAgregarPromo}
                handleClose={handleCloseAgregarPromo}
                datos={selectedRow}
                ObtenerListado={ObtenerListado}
            /> */}
        </div>
    )
}
